import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";

import { CDSMask } from '@app/utils/cds-mask';

import { OrgaoDoJudiciario } from '@app/models/orgao-do-judiciario.model';
import { OrgaoDoJudiciarioService } from '@app/services/orgao-do-juriciario.service';

@Component({
  selector: 'app-orgao-do-judiciario-form',
  templateUrl: './orgao-do-judiciario-form.component.html'
})
export class OrgaoDoJudiciarioFormComponent implements OnInit {

  titulo: string;
  lstErros: string[];
  cdsMask: CDSMask = new CDSMask();
  orgaosDoJudiciario: OrgaoDoJudiciario = new OrgaoDoJudiciario();
  aguardandoSolicitacao: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private orgaosDoJudiciarioService: OrgaoDoJudiciarioService) { }

  ngOnInit() {
    let id = this.route.params.subscribe(params => {
      let id = params['id'];
      this.titulo = id ? 'Editar Órgão do Judiciário' : 'Novo  Órgão do Judiciário';

      if (!id)
        return;

      this.orgaosDoJudiciarioService.obterPorId(id).toPromise().then(
        data => this.orgaosDoJudiciario = data,
        () => this.router.navigate(['./configuracoes/orgao-do-judiciario']));
    });
  }

  onSubmit() {
    this.aguardandoSolicitacao = true;
    this.orgaosDoJudiciarioService.gravar(this.orgaosDoJudiciario).toPromise().then(
      () => this.router.navigate(["./configuracoes/orgao-do-judiciario"]),
      (data: any) => {
        if (data.error){
          this.lstErros = data.error.errors;
        }
        this.aguardandoSolicitacao = false;
      });
  }
}
